<template>
	<div class='online-details'>
		<div class='content'>
			<h1>{{getText('WarningHeader')}}</h1>
			<p>{{getText('WarningHint')}}</p>

			<WarningMessage :message="error_message" v-if='error_message !== undefined && error_message.length > 0' />

		</div>
	</div>
</template>

<style scoped lang="scss">
	.online-details{
		position: relative;

		.content{
			width: 100%;

			p{
				padding: 20px 0px;
			}
		}
	}
</style>

<script>

import WarningMessage from "@/components/messages/WarningMessage";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "Warning",
	components: {
		WarningMessage
	},
	props: {
		error: {
			type: String
		}
	},
	data(){
		return {
			error_message: ""
		};
	},
	beforeMount(){
		this.error_message = this.error;
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		}
	}
}
</script>
